import {
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  inject,
} from '@angular/core';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ConnectsService } from '../../../services/connects.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Connects } from '../connects';
import { MobileAdminComponent } from '../mobile-admin/mobile-admin.component';

import { BehaviorSubject } from 'rxjs';
import { DataServiceService } from '../../../services/data-service.service';
import { ConnectsPagination, ListOption } from '../connects-interface';

@Component({
  selector: 'app-admin',
  standalone: true,
  templateUrl: './admin.component.html',
  styleUrl: './admin.component.scss',
  imports: [
    MobileAdminComponent,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    CommonModule,
  ],
})
export class AdminComponent implements OnInit {
  connectsDataSource: BehaviorSubject<ConnectsPagination> =
    new BehaviorSubject<ConnectsPagination>({
      content: [],
      pageable: { pageNumber: 0 },
      totalPages: 0,
    });
  pageNumbers: number[] = [];
  totalPages: number;
  displayedColumns: string[] = [
    'name',
    'street',
    'phone',
    'email',
    'reason',
    'fromCity',
    'itinerary',
    'checkin',
  ];
  dataSource: MatTableDataSource<Connects>;
  connectService = inject(ConnectsService);
  connect = {} as Connects;
  connects: Connects[];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('itinerary') itinerary!: ElementRef;
  @ViewChild('checkin') checkin!: ElementRef;
  @ViewChild('mobile') mobile!: ElementRef;
  @ViewChild('adminCheckDetails') adminCheckDetails!: ElementRef;
  listOption: ListOption = {
    searchName: '',
    page: 1,
    size: 25,
  };
  public number: number;

  constructor(private readonly dataServiceService: DataServiceService) {}
 

public ngOnInit(): void {
  this.getMobileData();
}

getMobileData() {
  this.dataServiceService.listOption$.subscribe((data: ListOption) => {
    this.listOption = {
      searchName: data.searchName,
      page: data.page,
      size: this.listOption.size,
    };
    this.getConnectList();
  });
}

getConnectList() {
  this.connectService
    .getConnectsWithSearch(
      this.listOption.searchName,
      this.listOption.page,
      this.listOption.size
    )
    .subscribe((data: ConnectsPagination) => {
      this.number = data.totalElements;
      this.connectsDataSource.next(data);
      this.connects = data.content;
      this.dataSource = new MatTableDataSource(this.connects);
      if (data.pageable.pageNumber >= 0) {
        this.pageNumbers = Array.from(
          { length: data.totalPages },
          (_, i) => i + 1
        );
      }
      this.totalPages = data.totalPages;
      this.dataSource.sort = this.sort;
    });
}

  getPage(item) {
    this.listOption.page = item;
    this.getConnectList();
  }
  next() {
    this.listOption.page = this.listOption.page + 1;
    this.getConnectList();
  }
  previous() {
    this.listOption.page = this.listOption.page - 1;

    this.getConnectList();
  }
  openModal(modelId?: string) {
    const modalElement = this.getModalElement(modelId);
    modalElement.style.display = 'block';
    modalElement.classList.add('show');
    modalElement.setAttribute('aria-hidden', 'false');
    modalElement.setAttribute('aria-modal', 'true');
  }

  closeModal(modelId?: string) {
    const modalElement = this.getModalElement(modelId);
    modalElement.style.display = 'none';
    modalElement.classList.remove('show');
    modalElement.setAttribute('aria-hidden', 'true');
    modalElement.removeAttribute('aria-modal');
  }
  private getModalElement(modelId?: string): HTMLElement {
    switch (modelId) {
      case 'itinerary':
        return this.itinerary.nativeElement;
      case 'checkin':
        return this.checkin.nativeElement;
      case 'adminCheckDetails':
        return this.adminCheckDetails.nativeElement;
      default:
        throw new Error('Invalid modal ID');
    }
  }
  getConnects(itinerary) {
    this.connect = itinerary;
  }

  onSubmit() {
    this.connectService.checkIn(this.connect.id, this.connect).subscribe();
  }

  public applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
}
